<template>
  <w-icon-wrapper icon-name='work-time-icon'>
    <path
      id='Pfad_55739'
      d='M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z'
      data-name='Pfad 55739'
      fill='currentColor'
    />
    <path
      id='Pfad_55740'
      d='M13,11.975v-5.9a1,1,0,0,0-2,0V12.8L16.293,18.1a1,1,0,0,0,1.414-1.414Z'
      data-name='Pfad 55740'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconTime' };
</script>
